import React, { useEffect, useState } from 'react';
import Slider from './slider';

interface HeaderProps {
    isMenuOpen: boolean;
    toggleMenu: () => void;
    images: string[];
}

const Header: React.FC<HeaderProps> = ({ isMenuOpen, toggleMenu, images }) => {
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header>
            <div className={`navbar ${isMenuOpen ? 'active' : ''}`}>
                <div className="navbar-logo-image">
                    <img className='logo' src="image/nuevo-logo.png" alt="Immunoconsultor logo" />

                </div>
                <div className={`navbar-redirect ${isMenuOpen ? 'active' : ''}`}>
                    <ul className='redirect-links'>
                        <li><a className={`link-item ${isMenuOpen ? 'active' : ''}`} href="#quienessomos" onClick={() => isMenuOpen && toggleMenu()}><i className="uil uil-users-alt"></i> quiénes somos</a></li>
                        <li><a className={`link-item ${isMenuOpen ? 'active' : ''}`} href="#immunocal" onClick={() => isMenuOpen && toggleMenu()}><i className="uil uil-capsule"></i> immunocal</a></li>
                        <li><a className={`link-item ${isMenuOpen ? 'active' : ''}`} href="#platinum" onClick={() => isMenuOpen && toggleMenu()}><i className="uil uil-award"></i> platinum</a></li>
                        <li><a className={`link-item ${isMenuOpen ? 'active' : ''}`} href="#ciencia" onClick={() => isMenuOpen && toggleMenu()}><i className="uil uil-flask"></i> ciencia</a></li>
                        <li><a className={`link-item ${isMenuOpen ? 'active' : ''}`} href="#negocio" onClick={() => isMenuOpen && toggleMenu()}><i className="uil uil-briefcase"></i> oportunidad de negocio</a></li>
                        <li><a className={`link-item ${isMenuOpen ? 'active' : ''}`} href="#contactanos" onClick={() => isMenuOpen && toggleMenu()}><i className="uil uil-envelope"></i> contáctanos</a></li>
                    </ul>
                </div>
                <i className={`uil uil-bars ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}></i>
            </div>

            <div className={`navbar2 ${isSticky ? 'active' : ''}`}>
                <img className={`logo hidden ${isSticky ? 'reveal' : ''}`} src="image/nuevo-logo.png" alt="Immunoconsultor logo" />
                <div className="navbar-redirect">
                    <ul className='redirect-links'>
                        <li><a className={`hidden link-item ${isSticky ? 'reveal' : ''}`} href="#quienessomos">quiénes somos</a></li>
                        <li><a className={`hidden link-item ${isSticky ? 'reveal' : ''}`} href="#immunocal">immunocal</a></li>
                        <li><a className={`hidden link-item ${isSticky ? 'reveal' : ''}`} href="#platinum">platinum</a></li>
                        <li><a className={`hidden link-item ${isSticky ? 'reveal' : ''}`} href="#ciencia">ciencia</a></li>
                        <li><a className={`hidden link-item ${isSticky ? 'reveal' : ''}`} href="#negocio">oportunidad de negocio</a></li>
                        <li><a className={`hidden link-item ${isSticky ? 'reveal' : ''}`} href="#contactanos">contáctanos</a></li>
                    </ul>
                </div>
                <i className={`hidden uil uil-bars ${isSticky ? 'reveal' : ''} ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}></i>
            </div>

            <div className={`slider ${isMenuOpen ? 'active' : ''}`}>
                <Slider images={images} />
            </div>
        </header>
    );
};

export default Header;
